import React from "react";

const SearchIcon = ({ color = "#6D7885", ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" {...rest}>
    <circle cx="8.5" cy="8.5" r="5.5" stroke={color} strokeWidth="1.5" />
    <path d="M13 13L17 17" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default SearchIcon;
